import { DayButtonProps } from "@/interfaces/calendar_type";
import { ListProjectsOnDay } from "./ListProjectsOnDay";

/**
 * A component for each day on the calendar
 * @param {number} day_number the day of the month
 */
export function MonthDayCard({ day_number, projects }: DayButtonProps) {
    return (
        <div className="h-52 border border-gray-300  text-center shadow-md ">
            <div className="text-xl font-bold">
                {day_number + 1}
            </div>

            <div className="overflow-y-auto h-44">
                {projects && projects.length > 0 &&
                    <ListProjectsOnDay projects={projects} />}
            </div>
        </div>
    );
}
